import { enhancedApi as generatedLearnerCoursesApi } from './learnerCourses'
import { learnerCourseCacheTags } from './learnerCourseCacheTags'

// The generator emits no cache tags, so they are applied here rather than patched back into
// `learnerCourses.ts` after every run. Import this hook from this module, never from
// `./learnerCourses`, or the cache tag is missing.
export const learnerCoursesApi = generatedLearnerCoursesApi.enhanceEndpoints({
  endpoints: learnerCourseCacheTags
})

export const { useListMyCoursesQuery, useStartMyCourseMutation } = learnerCoursesApi
